import { Component, ChangeDetectionStrategy, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ColorScheme, SettingStyle } from './models';
import { StyleSettingService } from '../../services/style-setting.service';

@Component({
  selector: 'app-setting-styles',
  templateUrl: './setting-styles.component.html',
  styleUrls: ['./setting-styles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingStylesComponent implements OnInit, OnDestroy {
  private _saveDefaultSetting = false;
  @Output() public readonly settingClose = new EventEmitter();
  public icons = CustomIcons;
  public settingFormChanges$: Observable<any>;
  public settingForm = new UntypedFormGroup({
    font: new UntypedFormControl('Arial'),
    letterSpacing: new UntypedFormControl('standard'),
    colorScheme: new UntypedFormControl('default')
  });

  constructor(private styleSettingService: StyleSettingService) {}

  public ngOnInit(): void {
    this.styleSettingService.recoverySettingForm(this.settingForm);
    this.settingFormChanges$ = this.settingForm.valueChanges.pipe(
      tap((res: SettingStyle) => {
        this.styleSettingService.changeFont(res.font);
        this.styleSettingService.changeLetterSpacing(res.letterSpacing);
        this.styleSettingService.changeColorScheme(res.colorScheme);
      })
    );
  }

  public close(): void {
    this.settingClose.emit();
  }

  public setDefaultSettings(): void {
    this._saveDefaultSetting = true;
    this.styleSettingService.setDefaultScheme();
    this.settingClose.emit();
  }

  public setColorScheme(colorScheme: ColorScheme): void {
    this.settingForm.get('colorScheme')?.setValue(colorScheme);
  }

  public ngOnDestroy(): void {
    if (!this._saveDefaultSetting) {
      this.styleSettingService.saveSettings(this.settingForm.value as SettingStyle);
    }
  }
}
